<template>
  <div class="jxzxItem">
    <Header title="详情"></Header>

    <div class="jxzxItem-asid">
      <p>{{ advItemLists.wbtitle }}</p>
      <!-- <p>
        发布人：<span>{{ advItemLists.wbauthor }}</span>
      </p>
      <p>
        编辑人：<span>{{ advItemLists.wbeditor }}</span>
      </p> -->
      <p>
        发布时间：<span>{{ advItemLists.wbdate }}</span>
      </p>
      <!-- <p>
        更新时间：<span>{{ advItemLists.wbupdatedate }}</span>
      </p> -->
    </div>

    <div class="jxzxItem-content">
      <p>正文内容：</p>
      <div v-html="advItemLists.wbcontent"></div>
    </div>

    <!-- <div class="jxzxItem-foot" v-if="isShow" @click="downloadFile">
      <van-button type="primary" size="large">下载附件</van-button>
    </div> -->
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      advItemLists: {},
      isShow: false
    };
  },
  methods: {
    async getList() {
      const params = {
        wbnewsid: this.$route.query.wbnewsid,
        ownerid: "1664271694"
      };
      const res = await Api.getVsbxq(params);
      this.advItemLists = res.data;
    },
    async downloadFile() {
      var url = this.advItemLists.baseURL + this.advItemLists.fjid; //"http://192.168.5.139:8080/bzb_njwhd/"

      // console.log(url)
      let link = document.createElement("a");

      link.setAttribute("href", url);
      link.setAttribute("download", this.advItemLists.fjname);
      link.click();

      window.URL.revokeObjectURL(link.href);

      // console.log(res);
      // window.open(url);
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.jxzxItem /deep/img {
  width: 100% !important;
  height: auto !important;
}
.jxzxItem /deep/table {
  width: 100% !important;
}
.jxzxItem-title {
  line-height: 34px;
  width: 90%;
  margin: 10px auto;
}

.jxzxItem-title a {
  text-decoration: none;
  color: @attendance-color-4;
  font-size: 18px;
  font-weight: 600;
}

.jxzxItem-asid {
  width: 90%;
  margin-left: 5%;
}

.jxzxItem-asid p {
  color: @attendance-color-2;
  font-size: 14px;
  margin: 7px 0;
}

.jxzxItem-asid p:nth-child(1) {
  color: @attendance-color-1;
  font-size: 18px;
  margin-top: 15px;
  font-weight: 600;
}

.jxzxItem-asid p span {
  font-weight: 600;
}

.jxzxItem-content {
  width: 90%;
  margin-left: 5%;
}

.jxzxItem-content p {
  display: block;
  color: @attendance-color-2;
  font-size: 15px;
  margin-bottom: 10px;
}

.jxzxItem-content div {
  width: 100%;
  padding: 0;
  color: @attendance-color-2;
  font-size: 14px;
  border: none;
  outline: none;
  font-weight: 600;
  word-break: break-word;
}

.jxzxItem-foot {
  position: fixed;
  width: 100%;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/jxzx/item.vue